import { useQuery } from '@tanstack/react-query'
import { Button, Flex, Form, Input, InputNumber, Radio, Space } from 'antd'
import dayjs from 'dayjs'
import { useFormik } from 'formik'
import CustomDataTable from 'general/components/CustomDataTable'
import BaseTextField from 'general/components/Forms/BaseTextField'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import KTFormInput, {
  KTFormInputBTDPickerType,
  KTFormInputType,
} from 'general/components/Forms/KTFormInput'
import ButtonGroupTab from 'general/components/Tab'
import Global from 'general/utils/Global'
import Utils, {
  findObjectInArray,
  getYearsFromDates,
} from 'general/utils/Utils'
import ValidationSchema from 'general/utils/ValidationSchema'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import useToken from 'hooks/useToken'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useRef, useState } from 'react'
import DraggableModal from '../DragableModal/DraggableModal'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import SelectOptions from 'general/constants/SelectOptions'
import useFilter from 'hooks/useFilter'
import useGetSerials from 'hooks/Queries/useGetSerials'
import _, { repeat } from 'lodash'
import TableAction from 'general/components/GroupButton/TableAction'
import { IconAction } from 'general/components/GroupButton/styles'
import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'
import ToastHelper from 'general/helpers/ToastHelper'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  thunkExportInvoiceById,
  thunkUpdateNumberFormatInvoices,
} from 'features/Invoice/invoiceSlice'
import { numberFormat as nFormat } from 'features/System/screens/SystemConfiguration/constants'
import {
  thunkGetCompanyProfile,
  thunkGetCompanyProfileTvan,
} from 'features/System/systemSlice'

function ModalUpdateNumberFormat(props) {
  const {
    show,
    onHide,
    title,
    onRowClicked,
    selectableRows,
    buttonAgreeVisibility,
    defaultTab,
    isInvoice = true,
    objectId,
    companyId,
    numberFormat,
  } = props
  const modalRef = useRef(null)
  const { token } = useToken()
  const [dataOld, setDataOld] = useState({})
  const [dataNew, setDateNew] = useState({})
  const [company, setCompany] = useState({})
  const dispatch = useAppDispatch()

  const [form] = Form.useForm()
  const [formOld] = Form.useForm()
  const [formLayout, setFormLayout] = useState('horizontal')
  const onFormLayoutChange = ({ layout }) => {
    setFormLayout(layout)
  }
  useEffect(() => {
    if (show) {
      getDataOld()
      getDataNew()
      getDataCompany()
    }
  }, [show])

  const getDataOld = async () => {
    try {
      const data = unwrapResult(
        await dispatch(
          thunkExportInvoiceById({
            invoiceId: objectId,
            dataType: 'old',
            companyId,
          }),
        ),
      )
      setDataOld(data)
    } catch (error) {
      console.log('ERROR getDataOld:', error)
    }
  }

  const getDataNew = async () => {
    try {
      const data = unwrapResult(
        await dispatch(
          thunkExportInvoiceById({
            invoiceId: objectId,
            dataType: '',
            companyId,
          }),
        ),
      )
      setDateNew(data)
    } catch (error) {}
  }

  const getDataCompany = async () => {
    try {
      const data = unwrapResult(
        await dispatch(thunkGetCompanyProfileTvan({ companyId })),
      )
      console.log('dataCompany', data)
      setCompany(data)
    } catch (error) {
      console.log('error', error)
    }
  }
  useEffect(() => {
    if (company) {
      const data =
        typeof company?.dataStatementInvoiceCurrent === 'string'
          ? JSON.parse(company.dataStatementInvoiceCurrent || '{}')
          : company?.dataStatementInvoiceCurrent || {}
      formOld.setFieldsValue(data)
    }
    if (numberFormat) {
      const data =
        typeof numberFormat === 'string'
          ? JSON.parse(numberFormat || '{}')
          : numberFormat || {}
      formOld.setFieldsValue(data)
      let dataSaveNew = {
        ...data,
        totalAmount: data?.currencyExchange,
        totalCost: data?.currencyExchange,
        exchangeTotalCost: data?.currencyExchange,
        conversionUnitPrice: data?.currencyExchange,
      }
      form.setFieldsValue(dataSaveNew)
    }
  }, [company])

  const submitSaveInvoice = async (invoiceIds, numberFormat) => {
    try {
      const data = unwrapResult(
        await dispatch(
          thunkUpdateNumberFormatInvoices({
            invoiceIds,
            numberFormat,
          }),
        ),
      )
      if (data?.result == 'success') {
        ToastHelper.showSuccess(
          'Cập nhật cấu hình thập phân hóa đơn thành công',
        )
        onHide()
        return
      } else {
        ToastHelper.showError('Cập nhật cấu hình thập phân hóa đơn thất bại')
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  return (
    <>
      <DraggableModal
        applyText="Đóng"
        ref={modalRef}
        // handleApplyChanges={handleApplyChanges}
        title={title}
        hasApplyButton={buttonAgreeVisibility}
        isOpen={show}
        onOpenChange={() => onHide()}
        width={'90%'}
        styles={{
          header: {
            borderBottom: Utils.cn('1px solid', token.colorBorderSecondary),
            margin: 0,
          },
          body: {
            padding: 0,
          },
          footer: {
            borderTop: Utils.cn('1px solid', token.colorBorderSecondary),
          },
        }}
      >
        <div style={{ paddingRight: 10, paddingLeft: 10 }}>
          <div className="row justify-content-center">
            <div className="col-6 border">
              <b>Data cấu hình cũ: </b>
              <a
                href={`${process.env.REACT_APP_BASE_URL}${dataOld?.fileURL}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`${process.env.REACT_APP_BASE_URL}${dataOld?.fileURL}`}
              </a>
              <iframe
                src={`${process.env.REACT_APP_BASE_URL}${dataOld?.fileURL}`}
                style={{ width: '100%', height: '70vh' }}
              />
              <Form
                form={formOld}
                initialValues={{ layout: formLayout }}
                onValuesChange={onFormLayoutChange}
                style={{
                  maxWidth: formLayout === 'inline' ? 'none' : 600,
                  marginTop: 10,
                }}
                onFinish={async (values) => {
                  console.log('Success:', values)
                }}
                layout="horizontal"
                labelCol={{ span: 6 }} // độ rộng label
                wrapperCol={{ span: 18 }} // độ rộng input
              >
                {nFormat?.map((item, index) => {
                  if (item) {
                    return (
                      <Form.Item
                        key={index}
                        label={item?.label}
                        name={item?.state}
                        rules={[
                          {
                            required: true,
                            message: 'Không thể để trống',
                          },
                        ]}
                      >
                        <InputNumber
                          disabled
                          style={{ width: '100%' }}
                          min={0}
                        />
                      </Form.Item>
                    )
                  }
                  return null
                })}
              </Form>
            </div>
            <div className="col-6 border">
              <b>Data cấu hình mới: </b>
              <a
                href={`${process.env.REACT_APP_BASE_URL}${dataNew?.fileURL}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`${process.env.REACT_APP_BASE_URL}${dataNew?.fileURL}`}
              </a>
              <iframe
                src={`${process.env.REACT_APP_BASE_URL}${dataNew?.fileURL}`}
                style={{ width: '100%', height: '70vh' }}
              />
              <Form
                form={form}
                initialValues={{ layout: formLayout }}
                onValuesChange={onFormLayoutChange}
                style={{
                  maxWidth: formLayout === 'inline' ? 'none' : 600,
                  marginTop: 10,
                }}
                onFinish={(values) => {
                  console.log('Success:', values)
                  let body = {
                    ...values,
                    totalAmount: values?.currencyExchange,
                    totalCost: values?.currencyExchange,
                    exchangeTotalCost: values?.currencyExchange,
                    conversionUnitPrice: values?.currencyExchange,
                  }
                  submitSaveInvoice([objectId], body)
                }}
                layout="horizontal"
                labelCol={{ span: 6 }} // độ rộng label
                wrapperCol={{ span: 18 }} // độ rộng input
              >
                {nFormat?.map((item, index) => {
                  if (!item?.hidden) {
                    return (
                      <Form.Item
                        key={index}
                        label={item?.label}
                        name={item?.state}
                        rules={[
                          {
                            required: true,
                            message: 'Không thể để trống',
                          },
                        ]}
                      >
                        <InputNumber style={{ width: '100%' }} min={0} />
                      </Form.Item>
                    )
                  }
                  return null
                })}

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginLeft: 150 }}
                  >
                    Cập nhật
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </DraggableModal>
    </>
  )
}

export default ModalUpdateNumberFormat
